import {Controller} from "@k/js/controller";
import {OwayoJSKonfiViewer} from "@k/js/owayoJSViewerWithSelObs";

export default {
    namespaced:true,
    state: () => ({
        controller:null as null|Controller,
        viewer:null as null|OwayoJSKonfiViewer,
        shaderEditorOpen:false,
        displayShaderEditorButton:false
    }),
    getters: {
        shaderEditorOpen:state=>state.shaderEditorOpen,
        shouldDisplayShaderEditorButton:state=>state.displayShaderEditorButton
    },
    mutations: {
        SET_CONTROLLER(state, controller:Controller) {
            state.controller = controller;
        },
        SET_VIEWER(state, viewer:OwayoJSKonfiViewer) {
            state.viewer = viewer;
        },
        CLOSE_SHADEREDITOR(state){
            state.shaderEditorOpen = false;
        },
        OPEN_SHADEREDITOR(state){
            state.shaderEditorOpen = true;
        },
        SHOW_SHADEREDITOR_BUTTON(state) {
          state.displayShaderEditorButton = true;
        }
    },
    actions: {},
}
